import type { DrugManualDetail } from '@/entities/drug-data/api/drug-data.api';
import { LoadingSpinner } from '@/shared/components/LoadingSpinner';
import { Button } from '@/shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';
import React, { useMemo } from 'react';

const DETAIL_FIELDS = [
  { key: 'drugCodePharma', label: '제약사 약품 코드' },
  { key: 'drugCodeMfds', label: '품목 기준 코드' },
  { key: 'drugName', label: '의약품 명' },
  { key: 'unitQuantity', label: '규격' },
  { key: 'baseUnit', label: '단위' },
  { key: 'reimbursementType', label: '급여상태' },
  { key: 'etcOtcType', label: '전문/일반 구분' },
  { key: 'dataSourceType', label: '정보구분' },
  { key: 'administrationRouteType', label: '투여경로' },
  { key: 'atcCode', label: 'ATC 코드' },
] as const;

const displayValue = (value: unknown) => {
  if (value === undefined || value === null || value === '') return '-';
  return String(value);
};

interface CreatedDrugDetailModalProps {
  open: boolean;
  loading?: boolean;
  detail?: DrugManualDetail | null;
  drugName?: string;
  drugCodePharma?: string;
  onClose: () => void;
}

export const CreatedDrugDetailModal: React.FC<CreatedDrugDetailModalProps> = ({
  open,
  loading = false,
  detail = null,
  drugName = '',
  drugCodePharma = '',
  onClose,
}) => {
  const rows = useMemo(() => {
    if (!detail) return [];
    return DETAIL_FIELDS.map(({ key, label }) => ({
      key,
      label,
      value: detail[key],
    }));
  }, [detail]);

  const subtitle = [drugName, drugCodePharma].filter(Boolean).join(' · ');

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>생성 의약품 상세</DialogTitle>
          {subtitle ? (
            <p className="text-sm text-muted-foreground">{subtitle}</p>
          ) : null}
        </DialogHeader>
        {loading ? (
          <LoadingSpinner tip="의약품 상세를 불러오는 중..." />
        ) : (
          <dl className="space-y-3 text-sm">
            {rows.map((row) => (
              <div key={row.key} className="flex justify-between gap-4">
                <dt className="font-medium text-muted-foreground">{row.label}</dt>
                <dd className="text-right">{displayValue(row.value)}</dd>
              </div>
            ))}
          </dl>
        )}
        <DialogFooter>
          <Button onClick={onClose}>확인</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
